module.exports = __webpack_public_path__ + "img/exam6.885b2144.png";